import { styled } from "@material-ui/styles";
import { Box, Typography } from "@material-ui/core";
export const SectionContainer = styled(Box)({
  width: 843,
  height:"auto",
  background: "rgba(249, 249, 249, 0.9) ",
  boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.05)",
  backdropFilter: "blur(15.5px)",
  borderRadius: "20px !important",
  marginLeft: "15%",
});
export const Title = styled(Typography)({ fontSize: 24, fontWeight: 600 });
